import React, { Component } from 'react';
import { connect } from 'react-redux';

import classes from './ContactModal.css';
import Aux from '../../hoc/Auxiliary/Auxiliary';
import Backdrop from '../UI/Backdrop/Backdrop';
import personImg from '../../assets/images/person-icon.png';
import deleteImg from '../../assets/images/delete-icon.png';
import closeImg from '../../assets/images/close-icon.png';
import arrowImg from '../../assets/images/arrow-right-icon.png';
import phoneImg from '../../assets/images/phone-icon.png';
import plusImg from '../../assets/images/plus-icon.png';
import sideBySideImg from '../../assets/images/side-by-side-icon.png';
import stackedImg from '../../assets/images/stacked-icon.png';
import axios from '../../axios-trips';
import logError from '../../store/LogError';
import * as actionTypes from '../../store/actions';
import saveImg from '../../assets/images/save-icon.png';
import historyImg from '../../assets/images/history-icon.png';
import Icon from '../UI/Icon/Icon';
import Button from '../UI/Button/Button';
import ButtonIconConfirm from '../UI/ButtonIconConfirm/ButtonIconConfirm';
import ButtonIcon from '../UI/ButtonIcon/ButtonIcon';
import Input from '../UI/Input/Input';
import Spinner from '../UI/Spinner/Spinner';
import Modal from '../UI/Modal/Modal';

class CarrierModal extends Component {

  createInputConfig = (elementType,
                       elementConfig,
                       label,
                       value='',
                       validation={},
                       valid=true,
                       extraAction=null,
                       extraClass=null) => {
    return ({
      elementType: elementType,
      elementConfig: elementConfig,
      label: label,
      value: value,
      validation: validation,
      valid: valid,
      extraAction: extraAction,
      extraClass: extraClass,
      touched: false,
      errorMessage: null
    });
  }

  state = {
    localCard: null,
    loading: false,
    showHistory: false,
    driver: -1,
    history: null,
    historyLoading: false,
    driverName: null,
    driverForm : {
      phones: this.createInputConfig(
        'driver-phones',
        {
          options: []
        },
        'Телефоны Водителя: ',
        '',
        {},
        true,
        {call: (ev, driver, phoneType, phoneNumber) => this.call(ev, driver, phoneType, phoneNumber)})
    }
  }

  call(ev, driver, phoneType, phoneNumber) {
    ev.preventDefault();

    let rawPhone = phoneNumber.replace(/\D+/g, "");
    if (rawPhone.length > 10) {
      rawPhone = rawPhone.substring(rawPhone.length - 10, rawPhone.length);
    }

    let data = {
      name: driver,
      tripId: null,
      status: "-",
      phoneType: phoneType,
      phoneNumber: rawPhone,
      outcome: null,
      customisable: false
    }

    axios({
      method: 'post',
      data: data,
      url: '/api/v1/carriers/trip',
      headers: {'Authorization': 'Bearer ' + this.props.access_token},
    })
    .then(response => {
      this.props.addNotification("Идет вызов водителю.", "Success");
    })
    .catch(error => {
      console.log(error);
      this.setState({ loading: false });
      if (error.response) {
        logError(
          this.props.access_token,
          this.props.codeToMessage[error.response.status],
          '/api/v1/carriers/trip'
        );
        this.props.addNotification(this.props.codeToMessage[error.response.status], "Danger");
      }
    });
  }

  getAttribute(carrier, attr) {
    if (carrier[attr]) {
      return carrier[attr];
    }
    return "";
  }

  getDriverPhones(driverId) {
    if (!this.state.loading) {
      this.setState({ loading: true });
    }
    axios({
      method: 'get',
      url: '/api/v1/drivers/phones?id=' + driverId,
      headers: {'Authorization': 'Bearer ' + this.props.access_token},
    })
    .then(response => {
      console.log(response);
      const updatedDriverForm = {...this.state.driverForm};
      let phones = [];
      let driverName = null;
      Object.keys(response.data).forEach(key => {
        phones.push({ phone: key, name: response.data[key] });
        driverName = response.data[key];
      });
      for (let i = 0; i < phones.length; i++) {
        phones[i] = {...phones[i], driver: this.props.driver };
      }
      updatedDriverForm.phones.value = phones;
      this.setState({ driverForm: updatedDriverForm, loading: false, driverName: driverName });
    })
    .catch(error => {
      console.log(error);
      this.setState({ loading: false });
      if (error.response) {
        logError(
          this.props.access_token,
          this.props.codeToMessage[error.response.status],
          '/api/v1/drivers/phones?id=' + driverId
        );
        this.props.addNotification(this.props.codeToMessage[error.response.status], "Danger");
      }
    });
  }

  parsePhones(phones) {
    let parsedPhones = [];
    Object.keys(phones).forEach(key => {
      parsedPhones.push({ phoneType: key, phoneNumber: phones[key] })
    });
    return parsedPhones;
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.driver && this.props.show && !prevProps.show) {
      this.setState({ driver: this.props.driver });
      this.getDriverPhones(this.props.driver);
    }
  }

  formatDate(date) {
    if (date === undefined) {
      return null;
    }
    return date.substring(8, 10) + "/" + date.substring(5, 7) + "/" + date.substring(2, 4) + " " + date.substring(11, 19);
  }

  render () {
    const driverFormArray = [];
    for (let key in this.state.driverForm) {
      driverFormArray.push({ id: key, config: this.state.driverForm[key] });
    }

    let loading = null;
    if (this.state.loading) {
      loading = (
        <Spinner />
      )
    }

    let headerClasses = [classes.Header];
    headerClasses.push(classes.HeaderWhite);

    let card = (
      <Aux>
        <div className={headerClasses.join(' ')}>

          <div className={classes.CarrierTitle}>
            <Icon iconClass={classes.CarIcon} iconSource={personImg} iconAlt='' className={classes.CardIcon} />
            Контакты
          </div>

          <button className={classes.CloseButton} onClick={this.props.close}>
            <Icon iconClass={classes.CloseIcon} iconSource={closeImg} iconAlt='' />
          </button>
          <p style={{height: "100%"}}></p>
        </div>

        <div className={classes.Body} >
          { loading }

          <h3>{ this.state.driverName }</h3>

          {driverFormArray.map(formElement => {
            return (
              <Input
                key={formElement.id}
                label={formElement.config.label}
                elementType={formElement.config.elementType}
                elementConfig={formElement.config.elementConfig}
                value={formElement.config.value}
                extraClass={formElement.config.extraClass}
                extraAction={formElement.config.extraAction}
                changed={(event) => this.inputChangedHandler(event, formElement.id)} />
              );
          })}

        </div>

        <div className={classes.Footer}>

          <div className={classes.FooterButtons}>
            </div>
        </div>
      </Aux>
    );

    let carrierClass = classes.CardModal;
    let extraStyle = this.props.noRestrictions ? { left: "50%", position: "absolute" } : {};
    return(
      <Aux>
        <Backdrop show={this.props.show && !this.props.noRestrictions} clicked={this.props.close} />
        <div
          className={carrierClass}
          style={{ transform: this.props.show ? 'translateY(0)' : 'translateY(-100vh)',
                  opacity: this.props.show ? '1' : '0',
                  ...extraStyle }}>
          {card}
        </div>
      </Aux>
    );
  }
};

const mapStateToProps = state => {
  return {
    access_token: state.access_token,
    notifications: state.notifications,
    codeToMessage: state.codeToMessage
  };
}

const mapDispatchToProps = dispatch => {
  return {
    addNotification: (notification, notificationType) => dispatch({ type: actionTypes.ADD_NOTIFICATION,
                                                                   notification: notification,
                                                                   notificationType: notificationType })
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CarrierModal);



// WEBPACK FOOTER //
// ./src/components/ContactModal/ContactModal.js